export default __webpack_public_path__ + "static/media/size_chart_data.8ec70f58.png";